import * as React from "react";
import { ContentPicker } from "../components/ContentPicker";
import { ImagePicker } from "../components/ImagePicker";
import { ContentViewModel, EntityTypes, ImageTypes, ListContent } from "../content/ContentStore";
const AliasSplashPicker = ({ onSelect, disabled, uri }) => {
    const [options, setOptions] = React.useState([] as ContentViewModel[]);

    React.useEffect(() => {
        ListContent(ImageTypes.Splash, EntityTypes.Alias, 0, 50).then((res) => {
            setOptions(res.result);
        });
    }, []);

    return <ContentPicker label="Splash" onSelect={onSelect} uri={uri} width="400px" options={options} optionWidth="256px" optionHeight="" optionsPageSize={3} suggestedSize="1024px x 512px" disabled={disabled}></ContentPicker>;
};

export default AliasSplashPicker;
